import Vue from 'vue'
import Router from 'vue-router'
import Home from './../Home/Home.vue'

Vue.use(Router)

// Router.beforeEach((to, from, next) => {
//   if (to.meta.metaInfo) {
//     store.commit("metaModule/CHANGE_META_INFO", to.meta.metaInfo)
//   }
//   next()
// })

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        metaInfo: {
          title: 'MPA联合体',
          keywords: 'MPA联合体,MPA,网根科技,网根,网根科技（北京）有限公司,网根科技（青岛）有限公司',
          description: '网根科技有限公司是经工业和信息化部批准，由中心控股，全球根节点（MPA）联合体三方共同发起成立的国家高新技术企业，是 MPA 联合体的实体化运营机构。 负责部署建设、运营管理位于中国的“一主根、三辅根”全球根节点，并致力于新一代互联网技术--数字对象架构（DOA）的研究及应用发展'
        }
      }
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      meta: {
        metaInfo: {
          title: 'MPA联合体',
          keywords: 'MPA联合体,MPA,网根科技,网根,网根科技（北京）有限公司,网根科技（青岛）有限公司',
          description: '网根科技有限公司是经工业和信息化部批准，由中心控股，全球根节点（MPA）联合体三方共同发起成立的国家高新技术企业，是 MPA 联合体的实体化运营机构。 负责部署建设、运营管理位于中国的“一主根、三辅根”全球根节点，并致力于新一代互联网技术--数字对象架构（DOA）的研究及应用发展'
        }
      }
    },
    {
      path: '/zh',
      name: 'zh',
      component: Home,
      meta: {
        metaInfo: {
          title: 'MPA联合体',
          keywords: 'MPA联合体,MPA,网根科技,网根,网根科技（北京）有限公司,网根科技（青岛）有限公司',
          description: '网根科技有限公司是经工业和信息化部批准，由中心控股，全球根节点（MPA）联合体三方共同发起成立的国家高新技术企业，是 MPA 联合体的实体化运营机构。 负责部署建设、运营管理位于中国的“一主根、三辅根”全球根节点，并致力于新一代互联网技术--数字对象架构（DOA）的研究及应用发展'
        }
      }
    },
    {
      path: '',
      name: 'Product',
      component: resolve => (require(['@/Products/Product.vue'], resolve)),
      children: [
        {
          path: '/prefix',
          name: 'zh-prefix',
          component: resolve => (require(['@/Products/components/Prefix.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '前缀产品',
              keywords: 'Handle,Handle码,Handle标识,工业互联网,追溯,一物一码,二级节点',
              description: '前缀是机构重要的虚拟资产，是机构、企业、个人等用户接入Handle全球体系架构和我国工业互联网标识解析体系的数字身份。'
            }
          }
        },
        {
          path: '/MultipleDataAggregation',
          name: 'zh-MultipleDataAggregation',
          component: resolve => (require(['@/Products/components/MultipleDataAggregation.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '多元数据归集系统',
              keywords: '网根北京,数据,数据安全,多元数据归集系统',
              description: '网根--多元数据归集系统”提供多元数据归集服务、数据安全流通服务、安全加固服务、以及可信利用服务四大方面的服务，确保支撑机构形成“对内数据有效归集、对外数据安全”共享的全场景能力。'
            }
          }
        },
        {
          path: '/infor-router',
          name: 'zh-InforRouter',
          component: resolve => (require(['@/Products/components/InforRouter.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '信息路由器',
              keywords: '信息路由器,Handle,Handle码,Handle标识,工业互联网,追溯,一物一码,二级节点',
              description: '信息路由器为每一条数据、每一个应用系统提供一个全球永久、唯一的身份信息，并使用更为安全的协议为数据传输提供可靠方式，借助信息路由器接入全球“数据总线”，帮助用户实现异构、异主、异地数据的互联互通与安全共享，帮助机构、企业降低成本、提升效率，提升安全性。'
            }
          }
        },
        {
          path: '/data-manage',
          name: 'zh-DataManage',
          component: resolve => (require(['@/Products/components/DataManage.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '数据管理系统',
              keywords: '数据管理,Handle,Handle码,Handle标识,工业互联网,追溯,一物一码,二级节点',
              description: '数据管理系统既可以帮助行业协会、龙头企业、大规模集团等建立行业性、区域性的数据治理体系，也可以帮助普通机构、企业建立符合行业、区域、国家乃至国际的数据管理机制，让机构、企业快速便捷地实现在全球化发展背景下的共同目标——让自身的数字化信息具备全球互联互通能力，数据将具备高质量、高可用性、高易用性、高安全性、高开放性、高系统性、高规范性、高扩展性、高兼容性，为开放的数字化转型提供数据基础支撑。'
            }
          }
        },
        {
          path: '/toolkit',
          name: 'zh-Toolkit',
          component: resolve => (require(['@/Products/components/Toolkit.vue'], resolve))
        }
      ]
    },
    {
      path: '',
      name: 'Solution',
      component: resolve => (require(['@/Solutions/Solution.vue'], resolve)),
      children: [
        {
          path: '/Field-Node',
          name: 'zh-fieldNode',
          component: resolve => (require(['@/Solutions/components/FieldNode.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '行业/领域节点解决方案',
              keywords: '数据管理,Handle,Handle码,Handle标识,工业互联网,追溯,一物一码,二级节点,工业互联网基础设施,工业互联网标识解析体系',
              description: '以Handle标识解析体系为基础，利用Handle分布式存储架构，遵循先进性、开放性、安全性、集成性、可扩展性等原则，建设标识解析信息系统，为各个行业提供行业/领域节点基础服务能力，包括标识注册、标识解析、标识代理服务、数据同步、业务综合管理等，达到对行业规范管理、加强统筹、资源共享、提升安全的目的。'
            }
          }
        },
        {
          path: '/life-cycle',
          name: 'zh-LifeCycle',
          component: resolve => (require(['@/Solutions/components/LifeCycle.vue'], resolve))
        },
        {
          path: '/class-electronic',
          name: 'zh-ClassElectronic',
          component: resolve => (require(['@/Solutions/components/ClassElectronic.vue'], resolve))
        },
        {
          path: '/smart-chain',
          name: 'zh-SmartChain',
          component: resolve => (require(['@/Solutions/components/SmartChain.vue'], resolve))
        },
        {
          path: '/simulation-root',
          name: 'zh-SimulationRoot',
          component: resolve => (require(['@/Solutions/components/SimulationRoot.vue'], resolve))
        },
        {
          path: '/Laboratory',
          name: 'zh-laboratory',
          component: resolve => (require(['@/Solutions/components/Laboratory.vue'], resolve))
        }
      ]
    },
    {
      path: '',
      name: 'Prefix Registration',
      component: resolve => (require(['@/PrefixLogin/PrefixLogin.vue'], resolve)),
      children: [
        {
          path: 'http://prefix.cndona.net:8080/handleDistributeManage/tourist/toSearchPrefix?prefixNameqian=86',
          name: 'zh-LeveOne'
        },
        {
          path: '/LeveEnd',
          name: 'zh-LeveEnd',
          component: resolve => (require(['@/PrefixLogin/components/LeveEnd.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '前缀注册',
              keywords: '前缀注册,数据管理,Handle,Handle码,Handle标识,工业互联网,追溯,一物一码,二级节点,工业互联网基础设施,工业互联网标识解析体系',
              description: '获得前缀服务机构分发的Handle前缀，并在本地开展应用的机构或个人（如：工业互联网企业节点、行业平台参与单位、大中型集团分支机构、小微企业等）。具有法人资格的组织机构或个人均可申请。前缀用户将拥有全球唯一的Handle前缀，并自主在该Handle前缀下分配不限数量的全球唯一标识，与经认证的开发者合作开发基于Handle的本地应用，既可独立开展服务，也可对接工业互联网二级节点，参与行业平台建设。'
            }
          }
        }
      ]
    },
    {
      path: '/newsList',
      name: 'zh-newsList',
      component: resolve => (require(['@/NewsList/NewsList.vue'], resolve))
    },
    {
      path: '/newsDetails',
      name: 'zh-newsDetails',
      component: resolve => (require(['@/NewsList/newsDetails.vue'], resolve))
    },
    {
      path: '/DOA',
      name: 'DOA',
      component: resolve => (require(['@/DOA/DOA.vue'], resolve)),
      children: [
        {
          path: '/DOAintroduce',
          name: 'zh-DOAintroduce',
          component: resolve => (require(['@/DOA/common/DOAintroduce.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '了解DOA',
              keywords: 'DOA,DOA技术,数字对象,Handle协议,DOIP协议,互联网架构',
              description: 'DOA是英文Digital Object Architecture的缩写，中文名称为数字对象体系架构。DOA就是对数据对象进行标识、解析、信息管理和安全控制的互联网架构，能够有效解决异主、异构、异地数据之间的互联互通互操作。'
            }
          }
        },
        {
          path: '/Inventor',
          name: 'zh-Inventor',
          component: resolve => (require(['@/DOA/common/Inventor.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '技术发明人',
              keywords: '罗伯特·卡恩,Robert E. Kahn,ATSD专家委员会荣誉主席,互联网之父,DONA基金会主席,DOA',
              description: '罗伯特·卡恩(Robert E. Kahn)博士，TCP/IP共同发明人、图灵奖获得者、美国国家科学院院士、DONA基金会主席、ATSD专家委员会荣誉主席，被誉为“互联网奠基人”、“互联网之父”。'
            }
          }
        },
        {
          path: '/DONAFoundation',
          name: 'zh-DONAFoundation',
          component: resolve => (require(['@/DOA/common/DONAFoundation.vue'], resolve)),
          meta: {
            metaInfo: {
              title: 'DONA基金会',
              keywords: 'DONA,全球架构,根节点,GHR,MPA,CNRI,ITU',
              description: 'DONA是DONA Foundation的缩写，中文名称为“数字对象规范命名机构,2014年，DONA由国际电信联盟（ITU）与美国国家研究创新机构（CNRI）共同发起，在瑞士日内瓦正式注册成立，是非政府间、非盈利性国际组织。该组织致力于推动数字对象体系架构（DOA）的应用，并负责全球Handle系统的运营与管理。 DONA不受制于任何一个国家，为公众利益而独立运营。DONA基金会负责授权、认证和协调全球多极最高授权管理者（MPA），对于Handle系统的标识、注册、解析服务进行总体管理、维护和协调。'
            }
          }
        },
        {
          path: '/ATSD',
          name: 'zh-ATSD',
          component: resolve => (require(['@/DOA/common/ATSD.vue'], resolve)),
          meta: {
            metaInfo: {
              title: 'ATSD',
              keywords: 'ATSD,数字对象',
              description: 'ATSD（DOA Application Technology ＆ Standardization Development Organization）主要致力于推动数字对象体系架构（DOA）的应用技术开发和应用标准促进工作。由中心、中国信息通信研究院、中国电信集团、北京中数创新科技股份有限公司、北京西恩多纳信息技术有限公司等机构于2017年联合发起创立，是一家注册在香港的非政府间、非盈利性国际组织。'
            }
          }
        }
      ]
    },
    {
      path: '/MPAIntr',
      name: 'MPAIntr',
      component: resolve => (require(['@/MPAIntr/MPAIntr.vue'], resolve)),
      meta: {
        metaInfo: {
          title: 'MPA联合体',
          keywords: 'MPA,MPA联合体',
          description: 'MPA联合体（CIC-CDI-CHC联合体）是由中心、北京中数创新科技股份有限公司（CDI）、北京西恩多纳信息技术有限公司（CHC）组成的联合体，又简称为MPA联合体。主要负责运营管理DONA部署在中国的全球多极最高授权管理者（MPA），其服务覆盖中国及亚大地区，对所服务范围内Handle系统的管理、运营和推广应用具有自主可控的管理权，可自主设计并建设分布式的国家解析节点以及行业解析节点等。'
        }
      },
      children: [
        {
          path: '/MPAorganization',
          name: 'zh-MPAorganization',
          component: resolve => (require(['@/MPAIntr/MPAcommon/MPAorganization.vue'], resolve))
        },
        {
          path: '/MPAintroduce',
          name: 'zh-MPAintroduce',
          component: resolve => (require(['@/MPAIntr/MPAcommon/MPAintroduce.vue'], resolve))
        }
      ]
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: resolve => (require(['@/AboutUs/AboutUs.vue'], resolve)),
      children: [
        // {
        //   path: '/Company',
        //   name: 'zh-company',
        //   component: resolve => (require(['@/AboutUs/AboutCommon/Company.vue'], resolve))
        // },
        {
          path: '/Onemian',
          name: 'zh-Onemian',
          component: resolve => (require(['@/AboutUs/AboutCommon/Onemian.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '“一主三辅”架构',
              keywords: '一主三辅,数据空间,数字对象架构体系',
              description: '目前按照“1主根、3辅根”的分布式顶层架构设计，我们部署了Handle全球根节点（北京）、Handle全球根节点（青岛）、Handle全球根节点（香港）。'
            }
          }
        },
        {
          path: '/NetRootBJ',
          name: 'zh-NetRootBJ',
          component: resolve => (require(['@/AboutUs/AboutCommon/NetRootBJ.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '网根科技（北京）',
              keywords: '网根科技（北京）,网根科技,网根北京,新一代互联网技术',
              description: '网根科技（北京）有限公司（以下简称“网根北京”）是经工业和信息化部批准，由中心控股，全球根节点（MPA）联合体三方共同发起成立的国家高新技术企业，是 MPA 联合体的实体化运营机构。 负责部署建设、运营管理位于中国的“一主根、三辅根”全球根节点，并致力于新一代互联网技术--数字对象架构（DOA）的研究及应用发展。'
            }
          }
        },
        {
          path: '/NetRootQD',
          name: 'zh-NetRootQD',
          component: resolve => (require(['@/AboutUs/NetRootQD/NetRootQD.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '网根科技（青岛）',
              keywords: '网根科技（青岛）,网根科技,网根科技青岛,数字化基础,青岛胶州湾,数字对象,数据互联互通',
              description: '网根科技（青岛）有限公司（以下简称“网根青岛”）成立于2021年7月16日，是青岛上合示范区管理委员会投资平台--青岛胶州湾科技投资有限公司和网根科技（北京）有限公司共同出资设立。网根青岛作为Handle全球根节点（青岛）的运营机构，通过数字对象体系架构（DOA）和Handle解析体系能力建设搭建国家数据互联互通服务平台和国际服务平台，构建全球标识和数据解析服务枢纽。 公司充分发挥青岛市和山东省的战略优势、区位优势、市场优势、产业优势、人才优势等，着力发展国际领先的新模式、新业态、新技术、新产业，立足青岛、服务上合、面向世界，特别为上合组织、“一带一路”、RCEP、金砖组织等国家提供数字化基础支撑。'
            }
          }
        },
        {
          path: '/Organization',
          name: 'zh-organization',
          component: resolve => (require(['@/AboutUs/AboutCommon/Organization.vue'], resolve))
        },
        {
          path: '/AttractInvestment',
          name: 'zh-attractinvestment',
          component: resolve => (require(['@/AboutUs/AboutCommon/AttractInvestment.vue'], resolve))
        },
        {
          path: '/JoinUs',
          name: 'zh-JoinUs',
          component: resolve => (require(['@/AboutUs/AboutCommon/JoinUs.vue'], resolve))
        }
      ]
    },
    {
      path: '/Supports',
      name: 'Supports',
      component: resolve => (require(['@/TechnicalSupports/Supports.vue'], resolve)),
      children: [
        {
          path: '/Technical_support',
          name: 'zh-Technical_support',
          component: resolve => (require(['@/TechnicalSupports/components/Technical_support.vue'], resolve))
        },
        {
          path: '/Technical_support_BJ',
          name: 'zh-Technical_support_BJ',
          component: resolve => (require(['@/TechnicalSupports/components/Technical_support_BJ.vue'], resolve))
        },
        {
          path: '/Technical_support_QD',
          name: 'zh-Technical_support_QD',
          component: resolve => (require(['@/TechnicalSupports/components/Technical_support_QD.vue'], resolve))
        },
        {
          path: '/FAQ',
          name: 'zh-FAQ',
          component: resolve => (require(['@/TechnicalSupports/components/FAQ.vue'], resolve)),
          meta: {
            metaInfo: {
              title: '常见问题',
              keywords: 'Handle System,Handle技术,Handle前缀,TCP/IP,DNS,IPV6,Handle ID',
              description: '网根科技（青岛）有限公司（以下简称“网根青岛”）成立于2021年7月16日，是青岛上合示范区管理委员会投资平台--青岛胶州湾科技投资有限公司和网根科技（北京）有限公司共同出资设立。网根青岛作为Handle全球根节点（青岛）的运营机构，通过数字对象体系架构（DOA）和Handle解析体系能力建设搭建国家数据互联互通服务平台和国际服务平台，构建全球标识和数据解析服务枢纽。 公司充分发挥青岛市和山东省的战略优势、区位优势、市场优势、产业优势、人才优势等，着力发展国际领先的新模式、新业态、新技术、新产业，立足青岛、服务上合、面向世界，特别为上合组织、“一带一路”、RCEP、金砖组织等国家提供数字化基础支撑。'
            }
          }
        },
        {
          path: '/Community',
          name: 'zh-community',
          component: resolve => (require(['@/TechnicalSupports/components/Community.vue'], resolve))
        }
      ]
    },
    {
      path: '/Related-Documents',
      name: 'zh-documents',
      component: resolve => (require(['@/Home/components/Documents.vue'], resolve)),
      children: [
        {
          path: '/Related-Documents-01',
          name: 'zh-documents-01',
          component: resolve => (require(['@/Home/components/documents/Documents-01.vue'], resolve))
        },
        {
          path: '/Related-Documents-02',
          name: 'zh-documents-02',
          component: resolve => (require(['@/Home/components/documents/Documents-02.vue'], resolve))
        },
        {
          path: '/Related-Documents-03',
          name: 'zh-documents-03',
          component: resolve => (require(['@/Home/components/documents/Documents-03.vue'], resolve))
        },
        {
          path: '/Related-Documents-04',
          name: 'zh-documents-04',
          component: resolve => (require(['@/Home/components/documents/Documents-04.vue'], resolve))
        },
        {
          path: '/Related-Documents-05',
          name: 'zh-documents-05',
          component: resolve => (require(['@/Home/components/documents/Documents-05.vue'], resolve))
        },
        {
          path: '/Related-Documents-06',
          name: 'zh-documents-06',
          component: resolve => (require(['@/Home/components/documents/Documents-06.vue'], resolve))
        },
        {
          path: '/Related-Documents-07',
          name: 'zh-documents-07',
          component: resolve => (require(['@/Home/components/documents/Documents-07.vue'], resolve))
        },
        {
          path: '/Agreement',
          name: 'zh-agreement',
          component: resolve => (require(['@/Home/components/documents/Agreement.vue'], resolve))
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js